import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';
import { DataForAddSubscription, ISubscription } from '../redux/subscriptions/types';
import { SubscriptionsInfo } from '../redux/subscriptionsInfo/types';
import { SupportedCurrencies } from '../redux/specialists/types';
import { CouponPreviewDetailsType } from '../shared';

const SUBSCRIPTION_API_PATH = `${environment.STRIPE_PAYMENTS_APP_URL}/subscription`;

export const fetchUserSubscriptions = async (userID: string): Promise<ISubscription[]> => {
  const subscriptionsList = await HttpHandler({
    url: `${environment.CLIENT_APP_URL}/client/profile/subscriptions?subscription_status=equal:active&orderBy=created_at.desc`,
    method: 'GET',
  });

  return subscriptionsList.data?.data;
};

export type CreateSubscriptionReturnType = {
  subscription_id: string;
  price_type: SupportedCurrencies;
  subscription_price_type?: string | null;
  amount: number;
  price_local: number;
  couponPreview: CouponPreviewDetailsType;
  firestore_subscription_id: string;
  subscription_interval_in_month: string;
  client_secret: string;
};

export const createSubscription = async (data: DataForAddSubscription): Promise<CreateSubscriptionReturnType> => {
  const { userID, ...dataForCreateSubscription } = data;

  const subscriptionResponse = await HttpHandler({
    url: `${environment.PAYMENTS_URL}/subscription/${data.userID}`,
    method: 'POST',
    data: dataForCreateSubscription,
  });

  return subscriptionResponse.data;
};

export const getPossibleSubscriptionIntervals = async (
  userID: string,
  therapistID?: string | null
): Promise<SubscriptionsInfo> => {
  const possibleSubscriptionIntervals = await HttpHandler({
    url: `${environment.PAYMENTS_URL}/subscription/intervals/${userID}/${therapistID}`,
    method: 'GET',
  });

  return possibleSubscriptionIntervals.data.data as SubscriptionsInfo;
};

export const cancelSubscription = async (userID?: string | null, subscriptionID?: string | null) => {
  if (!subscriptionID || !userID) throw new Error('subscription_cannot_be_undefined');

  const deleteResponse = await HttpHandler({
    url: `${environment.PAYMENTS_URL}/subscription/${userID}/${subscriptionID}`,
    method: 'DELETE',
  });

  return deleteResponse.data;
};

export const patchSubscription = async (
  data: Partial<ISubscription>,
  userID?: string | null,
  subscriptionID?: string | null
) => {
  if (!subscriptionID || !userID) throw new Error('subscription_cannot_be_undefined');

  const deleteResponse = await HttpHandler({
    url: `${environment.PAYMENTS_URL}/subscription/${subscriptionID}`,
    method: 'PATCH',
    data: {
      user_id: userID,
      pause_collection: data.pause_collection,
    },
  });

  return deleteResponse.data;
};

type ConfirmSubscriptionParams = {
  couponPreview?: CouponPreviewDetailsType | null;
};
type ConfirmSubscriptionReturnType = {
  clientSecret: string;
  amount: number;
  paymentType: 'subscription' | 'coupon';
};
export const confirmSubscription = async (subscriptionId: string, data: ConfirmSubscriptionParams) => {
  const { data: response } = await HttpHandler({
    url: `${SUBSCRIPTION_API_PATH}/${subscriptionId}/confirm`,
    method: 'POST',
    data,
  });

  return response.data as ConfirmSubscriptionReturnType;
};
